export default "__VITE_ASSET__7e457f71__"